import React from 'react';
import { Icon } from '@iconify/react';
import cx from './cx';

export const APP_BUTTON_VARIANT_CLASS = {
  primary: 'btn-primary-600',
  secondary: 'btn-secondary',
  'outline-secondary': 'btn-outline-secondary',
  'outline-primary': 'btn-outline-primary',
  'outline-primary-600': 'btn-outline-primary-600',
  'outline-success': 'btn-outline-success',
  'outline-warning': 'btn-outline-warning',
  'outline-danger': 'btn-outline-danger',
  'outline-danger-600': 'btn-outline-danger-600',
  'outline-info': 'btn-outline-info',
  danger: 'btn-danger',
  'danger-600': 'btn-danger-600',
  warning: 'btn-warning',
  success: 'btn-success-600',
  info: 'btn-info-600',
  link: 'btn-link',
};

/**
 * Bouton unique (classes Bootstrap / WowDash).
 */
const AppButton = ({
  as: Component = 'button',
  variant = 'primary',
  size,
  icon,
  iconWidth,
  iconClassName = '',
  loading = false,
  loadingLabel,
  className = '',
  disabled,
  type,
  children,
  ...rest
}) => {
  const isNativeButton = Component === 'button';

  return (
    <Component
      type={isNativeButton ? (type || 'button') : type}
      className={cx(
        'btn',
        size && `btn-${size}`,
        APP_BUTTON_VARIANT_CLASS[variant] || APP_BUTTON_VARIANT_CLASS.primary,
        className,
      )}
      disabled={isNativeButton ? (disabled || loading) : disabled}
      {...rest}
    >
      {loading ? (
        <>
          <span className="spinner-border spinner-border-sm me-1" aria-hidden />
          {loadingLabel || children}
        </>
      ) : (
        <>
          {icon ? (
            <Icon
              icon={icon}
              width={iconWidth}
              className={cx(children ? 'me-1' : '', iconClassName)}
              aria-hidden
            />
          ) : null}
          {children}
        </>
      )}
    </Component>
  );
};

export default AppButton;
